//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        fixed: {
            default: true
        },
        left: {
            type: String,
            default: "true"
        },
        title: {
            type: String,
            default: ""
        },
        backFn: {
            type: String,
            default: ""
        }
    },
    methods: {
        back() {
            if (!this.backFn) {
                this.$router.go(-1);
            } else {
                this.$emit('back');
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.vue